export default function FieldError({ id, children }) {
  if (!children) return null;
  return <div id={id} className="invalid-feedback d-block">{children}</div>;
}
